import type { Entry } from "contentful";
import type { TypeCardSectionSkeleton } from "@/types/contentful/generated";
import { mapEntryExperiences, type VariantData } from "./mapEntryExperiences";

type CardSectionEntry = Entry<TypeCardSectionSkeleton, undefined, string>;

export type CardSectionVariantData = VariantData<CardSectionEntry["fields"]>;

export const mapCardSectionExperiences = (experiences: unknown[] | undefined) =>
  mapEntryExperiences<CardSectionEntry["fields"]>(experiences, "cardSection");
